// extracted by mini-css-extract-plugin
export default {"fallback":"UKYqA60hbyl3Vib5Qqxc"};